import { IOrder } from 'models/Order.model'
import axiosApi from 'modules/api'
import { GetUserOrdersResponse } from 'pages/api/account/[address]/orders'

const fetchUserOrders = async (
  account: string,
  chainId?: number
): Promise<IOrder[]> => {
  const { data } = await axiosApi.get<GetUserOrdersResponse>(
    `/account/${account}/orders`,
    {
      params: {
        chainId,
      },
    }
  )
  return data.orders
}

export default fetchUserOrders
